import type { EndpointSpec, Translate } from '../../../components/apidocs';

/** Banks API — รายชื่อธนาคารที่ระบบรองรับ */
export const BANKS_ENDPOINTS = (t: Translate): EndpointSpec[] => [
  {
    method: 'GET',
    path: '/banks',
    description: t('apiDocs.getBanksDesc'),
    response: {
      status: 200,
      id: 'banks-res',
      code: `{
  "success": true,
  "data": [
    { "bank_name": "กรุงเทพ", "short_name": "BBL", "bank_code": "002" },
    { "bank_name": "กสิกรไทย", "short_name": "KBANK", "bank_code": "004" },
    { "bank_name": "กรุงไทย", "short_name": "KTB", "bank_code": "006" },
    { "bank_name": "ทีเอ็มบีธนชาต", "short_name": "TTB", "bank_code": "011" },
    { "bank_name": "ไทยพาณิชย์", "short_name": "SCB", "bank_code": "014" },
    { "bank_name": "กรุงศรี", "short_name": "BAY", "bank_code": "025" },
    { "bank_name": "ออมสิน", "short_name": "GSB", "bank_code": "030" },
    ...
  ],
  "total": 35
}`,
    },
    responseFields: {
      rows: [
        { name: 'bank_name', type: 'string', description: t('apiDocs.fieldBankNameTh') },
        { name: 'short_name', type: 'string', description: t('apiDocs.fieldShortName') },
        { name: 'bank_code', type: 'string', description: t('apiDocs.fieldBankCode') },
      ],
    },
  },
];
